module.exports = __webpack_public_path__ + "static/media/road-america-2025.ec1c5342.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/road-america-2025.png
// module id = 1148
// module chunks = 0